<template lang="pug">
    layout
        template(slot="title")

            // Title
            title-component(:title="$t('auth.forgotPassword.title')" type="h1")

        // Forgot password form
        forgot-form
</template>

<script>
    import ForgotPasswordForm from './ForgotPasswordForm';
    import Layout from '../Layout';
    import { Title } from '~components';

    export default {
        components: {
            ForgotForm: ForgotPasswordForm,
            Layout,
            TitleComponent: Title,
        },
    };
</script>
